import { render } from "./ApplicationShell.vue?vue&type=template&id=042ae3ca"
import script from "./ApplicationShell.vue?vue&type=script&lang=ts"
export * from "./ApplicationShell.vue?vue&type=script&lang=ts"
script.render = render

export default script